import type { CryptocurrencyPayment } from "@/types/payment";
import { KATContractInfo } from "./contract";
import {
  zkSync,
  mainnet,
  bsc,
  polygon,
  goerli,
  zkSyncTestnet,
} from "@wagmi/chains";

export const cryptoPayments = {
  zkSyncTestnet: {
    name: "zkSyncTest",
    symbol: zkSyncTestnet.nativeCurrency.symbol,
    enableOneClick: false,
    chain: zkSyncTestnet,
    tokenAddress: "0x0000000000000000000000000000000000000000",
    gas: 0.0012,
    mintFee: {
      USDAmount: 2,
      tokenAmount: 0.0012,
      token: {
        address: "0x0000000000000000000000000000000000000000",
        chainId: zkSyncTestnet.id,
        symbol: zkSyncTestnet.nativeCurrency.symbol,
      },
    },
  } as CryptocurrencyPayment,
  zkSyncKAT: {
    name: "Karat Token",
    symbol: zkSync.nativeCurrency.symbol,
    enableOneClick: false,
    chain: zkSync,
    tokenAddress: "0x0000000000000000000000000000000000000000",
    gas: 0.0012,
    mintFee: {
      USDAmount: 2,
      tokenAmount: parseFloat(
        process.env.NEXT_PUBLIC_CLAIMER_MINT_FEE_KAT as string
      ),
      token: {
        address: KATContractInfo.address,
        chainId: KATContractInfo.chainId,
        symbol: "KAT",
      },
    },
  } as CryptocurrencyPayment,
  zkSync: {
    name: "zkSync",
    symbol: zkSync.nativeCurrency.symbol,
    enableOneClick: false,
    chain: zkSync,
    tokenAddress: "0x0000000000000000000000000000000000000000",
    gas: 0.0012,
    mintFee: {
      USDAmount: 2,
      tokenAmount: parseFloat(
        process.env.NEXT_PUBLIC_CLAIMER_MINT_FEE_ETH as string
      ),
      token: {
        address: "0x0000000000000000000000000000000000000000",
        chainId: zkSync.id,
        symbol: zkSync.nativeCurrency.symbol,
      },
    },
  } as CryptocurrencyPayment,
  goerli: {
    name: "Goerli",
    symbol: goerli.nativeCurrency.symbol,
    enableOneClick: true,
    chain: goerli,
    tokenAddress: "0x0000000000000000000000000000000000000000",
    gas: 0.0012,
    mintFee: {
      USDAmount: 2,
    },
  } as CryptocurrencyPayment,
  ethereum: {
    name: "Ethereum",
    symbol: mainnet.nativeCurrency.symbol,
    enableOneClick: true,
    chain: mainnet,
    tokenAddress: "0x0000000000000000000000000000000000000000",
    gas: 0.0012,
    mintFee: {
      USDAmount: 2,
    },
  } as CryptocurrencyPayment,
  bsc: {
    name: "BSC",
    symbol: bsc.nativeCurrency.symbol,
    enableOneClick: true,
    chain: bsc,
    tokenAddress: "0x0000000000000000000000000000000000000000",
    gas: 0.0092,
    mintFee: {
      USDAmount: 2,
    },
  } as CryptocurrencyPayment,
  polygon: {
    name: "Polygon",
    symbol: polygon.nativeCurrency.symbol,
    enableOneClick: true,
    chain: polygon,
    tokenAddress: "0x0000000000000000000000000000000000001010",
    gas: 3.6324,
    mintFee: {
      USDAmount: 2,
    },
  } as CryptocurrencyPayment,
};

export enum ClaimerPaymentType {
  KAT = 0,
  ETH = 1,
}
